import {addCircularTabFocus, focusElement} from '@wix/panda-js-utils'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {CloseButton} from '../common/close-button'
import {Header} from '../common/header'
import {ModalProps} from './interfaces'
import s from './modal.scss'

export const Modal = ({
  children,
  closeModal,
  skin,
  closeButtonAsButton,
  className,
  dataHook,
  firstChildSelector,
  lastChildSelector,
  returnFocusElement,
  title,
  subtitle,
  withoutPadding,
  showAccessibilityMode,
}: ModalProps) => {
  const {t} = useTranslation()

  const grey = skin === 'grey'
  const withTitle = Boolean(title)

  const getPaddingBottom = () => {
    if (withTitle || withoutPadding || grey) {
      return 0
    }

    return 52
  }

  React.useEffect(() => {
    if (firstChildSelector && lastChildSelector) {
      addCircularTabFocus(firstChildSelector, lastChildSelector)
      focusElement({selector: firstChildSelector, canFocus: true})
    }

    return () => (returnFocusElement ? focusElement({selector: returnFocusElement, canFocus: true}) : null)
  }, [])

  return (
    <>
      <div className={s.underlay} />
      <div
        className={classNames(s.container, className, {
          [s.grey]: grey,
          [s.noPadding]: withTitle || withoutPadding,
        })}
        role="dialog"
        aria-modal="true"
        aria-labelledby={t('seatings_mobile_modal_eventName_aria')}
        aria-describedby={t('seatings_mobile_modal_mapView_aria')}
        style={{paddingBottom: getPaddingBottom()}}
        data-hook={dataHook}
      >
        <div id={t('seatings_mobile_modal_mapView_aria')} style={{display: 'none'}}>
          {t('seatings_mobile_modal_mapView_aria')}
        </div>
        {withTitle && !showAccessibilityMode ? (
          <Header
            title={title}
            subtitle={subtitle}
            weight="light"
            alignment="left"
            closeButtonAsButton={closeButtonAsButton}
            closeModal={closeModal}
          />
        ) : null}
        {children}
        {!withTitle ? <CloseButton closeButtonAsButton={closeButtonAsButton} closeModal={closeModal} /> : null}
      </div>
    </>
  )
}
